
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dovoz",
      function () {
        return require("private-next-pages/dovoz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dovoz"])
      });
    }
  